import { Box, Typography } from "@mui/material";

interface DaysCardProps {
    cardColor: string;
    cardType: string;
    totalHolidays?: number;
    daysAvailable?: number;
    untilDate?: string;
    thisYear?: number;
}

const DaysCard = ({
    cardColor,
    cardType,
    totalHolidays,
    daysAvailable,
    untilDate,
    thisYear,
}: DaysCardProps) => {
    return (
        <Box
            sx={{
                backgroundColor: cardColor,
                mr: 2,
                borderRadius: "10px",
                p: {
                    xl: 1,
                },
            }}
        >
            <Box sx={{ p: 1 }}>
                <Typography
                    sx={{
                        m: 0,
                        fontSize: "1.25rem",
                    }}
                    variant="h4"
                    fontWeight="bold"
                    mb="4px"
                    color="#3B3B3B"
                >
                    {daysAvailable}
                    <span style={{ fontSize: "1rem" }}>
                        {cardType === "daysApproved"
                            ? totalHolidays
                            : `/${totalHolidays}`}
                    </span>
                </Typography>
                <Typography
                    sx={{
                        m: 0,
                        fontSize: "0.67rem",
                    }}
                    variant="subtitle2"
                    fontWeight="bold"
                    mb="4px"
                    color="#3B3B3B"
                >
                    {cardType === "daysUsed" || cardType === "daysWaiting"
                        ? thisYear
                        : "DAYS AVAILABLE"}
                </Typography>
                <Typography
                    sx={{ m: 0 }}
                    variant="subtitle2"
                    fontWeight="bold"
                    mb="4px"
                    color="#3B3B3B"
                >
                    {cardType === "daysUsed" || cardType === "daysWaiting"
                        ? untilDate
                        : null}
                </Typography>
            </Box>
        </Box>
    );
};

export default DaysCard;
